export default "__VITE_ASSET__CEIAHI5k__"